var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.disp_isMessage
      ? _c("div", [
          _vm.disp_isErrorExt
            ? _c(
                "div",
                { staticClass: "error-messages" },
                [
                  _c("c-message-list", {
                    attrs: { r_errors: _vm.error_messages.ext[0].errors }
                  })
                ],
                1
              )
            : _c(
                "div",
                {
                  class: {
                    "success-messages": !_vm.disp_isError,
                    "error-messages": _vm.disp_isError
                  }
                },
                [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.error_messages.errmessage)
                    }
                  })
                ]
              )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ceab3db8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ceab3db8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/parts_com/viewMessageDetail.vue
// module id = 598
// module chunks = 0 1 2